import { connect } from "react-redux";
import SummaryCards from "./SummaryCards";

const mapStateToProps = (state) => ({
    fetchBenchmarkKpiTilesApi: state.BenchmarkFilteringReducer.fetchBenchmarkKpiTilesApi,
    scaleType: state.BenchmarkFilteringReducer.scaleType,
});

export default connect(mapStateToProps)(SummaryCards);
